import { find, first, isEmpty } from "lodash-es";

// Channel yang statusnya active (yang pending/archived tidak tampil di sidebar).
export const getActivePhoneNumbers = (phoneNumbers, activeStatusId) =>
  (phoneNumbers || []).filter(
    (phoneNumber) => phoneNumber.status_id === activeStatusId,
  );

// Channel yang boleh diakses user — sumber tunggal untuk sidebar, channel
// default setelah login/refetch inits, validasi :id di URL, dan link Home.
// - assign mode mati / administrator → semua channel active
// - assign mode aktif & non-admin   → hanya channel active yang punya roles
//   (roles diturunkan backend dari divisi: 1 = supervisor, 2 = agen)
export const getAccessiblePhoneNumbers = ({
  phoneNumbers,
  activeStatusId,
  isAssignMode,
  isAdministrator,
}) => {
  const activePhoneNumbers = getActivePhoneNumbers(phoneNumbers, activeStatusId);
  if (!isAssignMode || isAdministrator) {
    return activePhoneNumbers;
  }
  return activePhoneNumbers.filter(
    (phoneNumber) => !isEmpty(phoneNumber.roles),
  );
};

// Channel dari :id di URL jika boleh diakses, selain itu channel pertama yang
// boleh diakses. Return undefined jika tidak ada channel yang bisa diakses.
export const resolveSelectedPhoneNumber = (
  accessiblePhoneNumbers,
  phoneNumberId,
) => {
  const matched = phoneNumberId
    ? find(accessiblePhoneNumbers, (row) => `${row.id}` === `${phoneNumberId}`)
    : undefined;
  return matched || first(accessiblePhoneNumbers);
};
